import { Textarea as NextTextarea } from "@heroui/react";
import { withFormComponent } from "./hoc";

export const Textarea = withFormComponent(NextTextarea); 